import { create } from 'zustand';
import { createCardStore } from './slice/cardStore';
import { createTransportationTab } from './slice/transportationTabStore';
import { createCarTab } from './slice/carTabStore';
import { createEmployeesStore } from './slice/employeesStore';
import { createLayerStore } from './slice/layerStore';
import { createInfoStore } from './slice/infoStore';

const useDashboardStore = create((...a) => ({
  ...createTransportationTab(...a),
  ...createCarTab(...a),
  ...createCardStore(...a),
  ...createEmployeesStore(...a),
  ...createLayerStore(...a),
  ...createInfoStore(...a),
  fetcError: null,
  onLiveTab: true,
  error: '',
  setError: (error) =>
    a[0]({
      error,
    }),
  resetError: () =>
    a[0]({
      error: '',
    }),
  setTrueLiveTab: () => {
    console.log('setTrueLiveTab');
    return a[0]({
      onLiveTab: true,
    });
  },
  setFalseLiveTab: () =>
    a[0]({
      onLiveTab: false,
    }),
  center: [37.874641, 32.493156],
  setCenter: (center) =>
    a[0]({
      center,
    }),
}));
export { useDashboardStore };
